module.exports = __webpack_public_path__ + "img/prosthesis.3b968104.gif";